<template>
  <div class="navigation-page-editor">
    <el-form ref="form" :model="form" :label-width="isEn() ? '180px' : '180px'" label-position="left">
      <el-form-item :label="$t('microSite.navigationPage.label.topPadding')">
        <el-input v-model="form.page.layout.topPadding" type="number">
          <template #append>px</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.navigationPage.label.horizontalPadding')">
        <el-input v-model="form.page.layout.horizontalPadding" type="number">
          <template #append>px</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="color" :label="$t('microSite.navigationPage.label.textColor')">
        <el-color-picker v-model="form.color"></el-color-picker>
        <span class="color-text">{{ form.color }}</span>
      </el-form-item>
      <el-form-item prop="lineColor" :label="$t('microSite.navigationPage.label.lineColor')">
        <el-color-picker v-model="form.lineColor"></el-color-picker>
        <span class="color-text">{{ form.lineColor }}</span>
      </el-form-item>
      <el-form-item prop="linePadding" :label="$t('microSite.navigationPage.label.linePadding')">
        <el-input v-model="form.linePadding" type="number">
          <template #append>px</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="fontSize" :label="$t('microSite.navigationPage.label.fontSize')">
        <el-select v-model="form.fontSize">
          <el-option v-for="fontSize in fontSizeList" :key="fontSize" :label="fontSize" :value="fontSize"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="page.title" :label="$t('microSite.navigationPage.label.pageTitle')">
        <el-input v-model="form.page.title.text"></el-input>
      </el-form-item>
      <el-form-item prop="page.background" :label="$t('microSite.navigationPage.label.background')">
        <ImageUpload v-model="form.page.background.image" :otherTips="uploadTip"></ImageUpload>
      </el-form-item>
      <el-form-item prop="page" :label="$t('microSite.navigationPage.label.bottomBtn')">
        <div class="btn-container">
          <div class="btn">
            <span class="label">{{ $t('microSite.navigationPage.label.leftBottomBtn') }}</span>
            <div class="btn-name">
              <el-input v-model="form.page.bottomLeftBtn.label"></el-input>
              <div class="control-display">
                <el-switch v-model="form.page.bottomLeftBtn.show"></el-switch>
              </div>
            </div>
            <div class="btn-link">
              <LinkSelector :link="form.page.bottomLeftBtn.link"></LinkSelector>
            </div>
          </div>
          <div class="btn">
            <span class="label">{{ $t('microSite.navigationPage.label.rightBottomBtn') }}</span>
            <div class="btn-name">
              <el-input v-model="form.page.bottomRightBtn.label"></el-input>
              <div class="control-display">
                <el-switch v-model="form.page.bottomRightBtn.show"></el-switch>
              </div>
            </div>
            <div class="btn-link">
              <LinkSelector :link="form.page.bottomRightBtn.link"></LinkSelector>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="page" :label="$t('microSite.navigationPage.label.page')">
        <div class="navigation-editor-menu">
          <el-button @click="onAddClick(form.page)">{{ $t('microSite.navigationPage.btn.addMenu') }}</el-button>
        </div>
        <PageMenu
          :menu-page-list="form.page.menu.list"
          @add="onAddClick"
          @edit="onEditClick"
          @delete="onDeleteClick"
          @expand="onExpandClick"
          @active="onActiveClick"
        />
      </el-form-item>
    </el-form>
    <PageEditor
      :is-edit="editor.isEdit"
      :menuPage="editor.menuPage"
      :colorIndex.sync="colorIndex"
      :show.sync="editor.show"
      :has-delete-btn="editor.isEdit"
      @save="onPageEditorSave"
      @delete="onPageEditorDelete"
    ></PageEditor>
  </div>
</template>

<script>
import _ from 'lodash'
import { isEn } from '@/i18n'
import editorTemplate from '../../editorTemplate'
import ImageUpload from '../../../components/editor/imageUpload.vue'
import LinkSelector from '../../../components/link/index.vue'
import PageMenu from './pageMenu.vue'
import PageEditor from './pageMenu/pageEditor.vue'

export default {
  components: {
    PageMenu,
    ImageUpload,
    PageEditor,
    LinkSelector
  },
  mixins: [editorTemplate],
  data () {
    return {
      colorIndex: 0,
      nextMenuId: 1,
      fontSizeList: '8px 10px 12px 14px 16px 18px 24px 36px 48px'.split(' '),
      form: {
        singlePage: false,
        color: '#909399',
        lineColor: '#303133',
        linePadding: 20,
        fontSize: '16px',
        page: {
          layout: {
            topPadding: 60,
            horizontalPadding: 20
          },
          title: {},
          background: {},
          label: {},
          menu: { list: [] },
          bottomLeftBtn: {
            label: null,
            show: false,
            link: {
              url: null,
              isInnerPage: false,
              openInNewWindow: true
            }
          },
          bottomRightBtn: {
            label: null,
            show: false,
            link: {
              url: null,
              isInnerPage: false,
              openInNewWindow: true
            }
          }
        }
      },
      editor: {
        isEdit: false,
        show: false,
        parent: null,
        menuPage: null
      }
    }
  },
  computed: {
    uploadTip () {
      return ''
    }
  },
  created () {
    const props = this.renderData.data.props

    this.form.singlePage = props.singlePage
    this.form.color = props.color || '#909399'
    this.form.lineColor = props.lineColor || '#303133'
    this.form.linePadding = props.linePadding || 20
    this.form.fontSize = props.fontSize || '16px'
    this.form.page = this.parsePropsPage(props.page)
  },
  methods: {
    isEn,
    parsePropsPage (page) {
      page = _.cloneDeep(page)
      this.nextMenuId = 1
      this.resetMenuItemProps(page.menu)
      this.resetBottomButton(page)
      page.menu.isExpand = true
      return page
    },
    resetMenuItemProps (menu) {
      if (!menu) {
        return
      }
      menu.isExpand = false
      menu.id = this.nextMenuId
      this.nextMenuId += 1
      _.forEach(menu.list, menuItem => {
        menuItem.label.isRichText = Boolean(menuItem.label.html)
        this.resetMenuItemProps(menuItem)
      })
    },
    resetBottomButton (page) {
      if (!_.has(page, 'bottomLeftBtn')) {
        page.bottomLeftBtn = {
          label: null,
          show: false,
          link: {
            url: null,
            isInnerPage: false,
            openInNewWindow: true
          }
        }
      }
      if (!_.has(page, 'bottomRightBtn')) {
        page.bottomRightBtn = {
          label: null,
          show: false,
          link: {
            url: null,
            isInnerPage: false,
            openInNewWindow: true
          }
        }
      }
    },
    formateFormPage (page) {
      page = _.cloneDeep(page)
      this.removeMenuItemData(page.menu)
      return page
    },
    removeMenuItemData (menu) {
      delete menu.isExpand
      _.forEach(menu.list, menuItem => {
        delete menuItem.label.isRichText
        delete menuItem.id
        this.removeMenuItemData(menuItem)
      })
    },
    getNextMenuId () {
      const id = this.nextMenuId
      this.nextMenuId += 1
      return id
    },
    onAddClick (menuPage, index, parentMenuPage) {
      this.editor.isEdit = false
      this.editor.parent = menuPage
      this.editor.menuPage = null
      this.editor.show = true
    },
    onEditClick (menuPage, index, parentMenuPage) {
      this.editor.isEdit = true
      this.editor.parent = parentMenuPage
      this.editor.menuPage = menuPage
      this.editor.show = true
    },
    onDeleteClick (menuPage, index, parentMenuPage) {
      if (!parentMenuPage) {
        parentMenuPage = this.form.page
      }
      parentMenuPage.menu.list.splice(index, 1)
    },
    onExpandClick (menuPage, index, parentMenuPage) {
      menuPage.menu.isExpand = !menuPage.menu.isExpand
    },
    onActiveClick (menuPage, index, parentMenuPage) {
      menuPage.menu.isActive = !menuPage.menu.isActive
      if (menuPage.menu.isActive) {
        menuPage.menu.isExpand = true
      }
    },
    onPageEditorDelete () {
      if (!this.editor.isEdit) {
        return
      }
      this.editor.show = false
      const parent = this.editor.parent || this.form.page
      const menuList = parent.menu.list
      const index = menuList.indexOf(this.editor.menuPage)
      menuList.splice(index, 1)
    },
    onPageEditorSave (data) {
      this.editor.show = false
      if (this.editor.isEdit) {
        const menuPage = this.editor.menuPage
        menuPage.label = data.label
        menuPage.link = data.link
        menuPage.menu.isActive = data.hasSubMenu
        menuPage.title = data.title
        menuPage.layout = data.layout
        menuPage.background = data.background
        menuPage.textColor = data.textColor
        menuPage.lineColor = data.lineColor
      } else {
        const parent = this.editor.parent
        parent.menu.isActive = true
        parent.menu.list.push({
          label: data.label,
          link: data.link,
          title: data.title,
          layout: data.layout,
          background: data.background,
          menu: {
            isActive: data.hasSubMenu,
            isExpand: data.hasSubMenu,
            list: []
          },
          id: this.getNextMenuId()
        })
      }
      this.editor.parent = undefined
      this.editor.menuPage = undefined
    },
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.page.title.text
      props.color = this.form.color
      props.lineColor = this.form.lineColor
      props.linePadding = this.form.linePadding
      props.fontSize = this.form.fontSize
      props.singlePage = this.form.singlePage
      props.page = this.formateFormPage(this.form.page)

      this.updateConfigInRoot()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-page-editor {
  width: 80vw;
  min-height: 200px;
  word-break: break-word;
  .el-color-picker {
    vertical-align: middle;
  }
  .color-text {
    margin-left: 15px;
    vertical-align: middle;
  }
  .size-config {
    .el-slider {
      margin-top: 15px;
    }
    .el-input {
      margin-top: 15px;
      ::v-deep {
        .el-input__inner[type="number"] {
          appearance: textfield;
          &::-webkit-inner-spin-button {
            appearance: none;
          }
        }
      }
    }
  }
  .navigation-editor-menu {
    margin-bottom: 5px;
  }
  .btn-container {
    .btn {
      .label {
        display: inline-block;
        vertical-align: middle;
        width: 100px;
        word-break: break-word;
      }
      .btn-name {
        display: inline-flex;
        width: 50%;
        .el-input {
          margin-right: 20px;
        }
      }
      .btn-link {
        margin-left: 100px;
        margin-top: 16px;
        .image-link {
          ::v-deep {
            .link-container {
              margin-top: 0;
              .link-path {
                width: 390px;
              }
            }
          }
        }
      }
      .control-display {
        flex: 1;
        .control-title {
          margin-right: 20px;
        }
      }
      &:last-child {
        margin-top: 20px;
      }
    }
  }
}
</style>
